<template>

	<ERWindow ref='_window' er-notification-window
		chain='notifications'
		:options='{ disable_teleport: true }'
		:actions='{ header: [], tray: [] }'
		:timeout='timeout'>
		<div class='icon default'><i class='fa-regular fa-message'></i></div>
		<div class='icon success'><i class='fa fa-check'></i></div>
		<div class='icon info'><i class='fa fa-circle-info'></i></div>
		<div class='icon warning'><i class='fa-solid fa-warning'></i></div>
		<div class='icon error'><i class='fa-solid fa-circle-xmark'></i></div>
		<slot />
	</ERWindow>

</template>

<script setup>

	import { ref } from 'vue';

	import ERWindow from '@/components/emergency/EmergencyWindow.vue';

	//

	const _window = ref();

	const _props = defineProps( { timeout: Object } );

	defineExpose( { Open, Close } );

	let _can_open = true;

	//

	async function Open ()
	{
		if ( _can_open )
		{
			await _window.value.Open();

			let counter = _window.value.Get_element()?.querySelector( '[er-window-timeout] .count' );

			if ( counter && ( _props.timeout?.amount > 0 ) )
			{
				counter.style.transitionDuration = ( _props.timeout.amount + 0 ) + 's';
				setTimeout( () => counter.style.transform = "translateX(100%)", 5 );
			}

			_can_open = false;
		}
	}


	function Close ()
	{
		_window.value.Close();
	}

</script>
